import React, { useEffect, useState } from 'react';
import { EventActions, useEventActions } from 'src/store/event/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import { RootState } from 'src/store/reducers/state';
import Loader from 'src/components/loader';
import EventReminderModal from './EventReminderModal';
import DeleteEventReminderModal from './DeleteEventReminderModal';
export const EventReminders = () => {
    const dispatch = useDispatch();
    const EventAction = useEventActions(dispatch);
    const { eventId } = useParams<string>();
    const [selectedReminder, setSelectedReminder] = useState<any>(null);
    const [modalFlag, setModalFlag] = useState<'add' | 'edit'>('add');
    const [modalKey, setModalKey] = useState(0);
    const [reminderNumber, setReminderNumber] = useState<number>(0);
    const { eventReminder, isEventReminderLoading, isEventReminderUpdated, isEventReminderDeleted } = useSelector(
        (state: RootState) => {
            return {
                eventReminder: state.event.eventReminder,
                isEventReminderLoading: state.event.isEventReminderLoading,
                isEventReminderUpdated: state.event.isEventReminderUpdated,
                isEventReminderDeleted: state.event.isEventReminderDeleted
            };
        }
    );

    useEffect(() => {
        eventId && EventAction.getEventReminderRequest(eventId);
    }, [isEventReminderUpdated, isEventReminderDeleted]);


    const handleEditClick = (reminder: any) => {
        setSelectedReminder(reminder);
        setModalFlag('edit');
        setModalKey((k) => k + 1);
    };

    const handleAddClick = () => {
        setSelectedReminder(null);
        setModalFlag('add');
        setModalKey((k) => k + 1);
    };

    const handleDeleteClick = (reminderNumber: number) => {
        setReminderNumber(reminderNumber)
    };

    const triggerLabel = (minutes: any) => {
        if (minutes === null || minutes === undefined || minutes === '') return '-';
        const map: Record<number, string> = {
            60: '1 hour', 120: '2 hours', 240: '4 hours', 720: '12 hours',
            1440: '24 hours', 2880: '48 hours', 4320: '72 hours', 5760: '96 hours', 10080: '1 week'
        };
        return map[Number(minutes)] || `${minutes} min`;
    };

    return (
        <div className="min-w-0">
            <div className="sm:shadow p-0 sm:p-5 sm:border">
                <div className="w-full h-full">
                    <div className="w-full">
                        <div>
                            <div className="flex flex-col justify-center h-full">
                                <div className="w-full mx-auto bg-white shadow-card rounded-lg relative">
                                    <div className="px-3 sm:px-5 py-3 sm:py-4 border-b border-gray-100 flex justify-end items-center">
                                        <h2 className="font-semibold m-0"></h2>
                                        <div className="w-full sm:w-auto flex items-center text-center">
                                            <button
                                                type="button"
                                                className="btn-primary w-full sm:w-auto whitespace-nowrap mt-0 mb-1"
                                                onClick={handleAddClick}
                                                data-bs-toggle="modal"
                                                data-bs-target="#eventReminderModal">
                                                Add Reminder
                                            </button>
                                        </div>
                                    </div>
                                    <div className="p-0 sm:p-3 pt-3">
                                        <div className="overflow-x-auto">
                                            <table className="table-auto w-full border sm:min-w-[480px]">
                                                <thead className="text-[11px] sm:text-xs font-semibold uppercase bg-gray-50 whitespace-nowrap">
                                                    <tr>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-left">Name</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-left">Trigger</div>
                                                        </th>
                                                        <th className="p-2 hidden sm:table-cell">
                                                            <div className="font-semibold text-left">When</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-left">Status</div>
                                                        </th>
                                                        <th className="p-2 w-10"></th>
                                                    </tr>
                                                </thead>
                                                {isEventReminderLoading ? (
                                                    <Loader />
                                                ) : (
                                                    <>
                                                        {eventReminder && eventReminder.length ? (
                                                            <tbody className="text-xs sm:text-sm divide-y divide-gray-100 sm:whitespace-nowrap">
                                                                {eventReminder &&
                                                                    eventReminder.map((item: any, index: number) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td className="p-2">
                                                                                    <div className="text-left">{`Reminder-${item.emailReminderNumber}`}</div>
                                                                                </td>
                                                                                <td className="py-2 px-2">
                                                                                    {triggerLabel(item.emailRemiderTriggerInMinutes)}
                                                                                    <span className="block sm:hidden text-gray-400">
                                                                                        {item.emailReminderType == 1 ? 'Before' : 'After'}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="py-2 px-2 hidden sm:table-cell">{item.emailReminderType == 1 ? 'Before' : 'After'}</td>
                                                                                <td className="p-2">
                                                                                    <span
                                                                                        className={`inline-block px-2 py-1 text-xs font-semibold rounded-md ${item.emailReminder
                                                                                            ? 'bg-green-100 text-green-800'
                                                                                            : 'bg-gray-100 text-gray-800'
                                                                                            }`}>
                                                                                        {item.emailReminder ? 'Active' : 'Inactive'}
                                                                                    </span>
                                                                                </td>
                                                                                <td className="p-2">
                                                                                    <div className="text-left">
                                                                                        <div className="dropdown relative">
                                                                                            <button
                                                                                                className="dropdown-toggle"
                                                                                                type="button"
                                                                                                id="action-dropdown"
                                                                                                data-bs-toggle="dropdown"
                                                                                                aria-expanded="false">
                                                                                                <img
                                                                                                    src="../../assets/img/dots-vertical.svg"
                                                                                                    className="w-5 h-5"
                                                                                                />
                                                                                            </button>
                                                                                            <ul
                                                                                                className="dropdown-menu dropdown-menu-ul dropdown-menu-end"
                                                                                                aria-labelledby="action-dropdown">

                                                                                                <li>
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        onClick={() => handleEditClick(item)}
                                                                                                        className="action-menu flex items-center"
                                                                                                        data-bs-toggle="modal"
                                                                                                        data-bs-target="#eventReminderModal">
                                                                                                        <i className="fas fa-edit w-6 text-left"></i>
                                                                                                        <span>Edit</span>
                                                                                                    </button>
                                                                                                </li>
                                                                                                <li>
                                                                                                    <span
                                                                                                        data-bs-toggle="modal"
                                                                                                        data-bs-target="#DeleteEventReminderModal"
                                                                                                        className="action-menu flex items-center cursor-pointer text-red-500"
                                                                                                        onClick={() => handleDeleteClick(item.emailReminderNumber)}
                                                                                                    >
                                                                                                        <i className="fas fa-trash w-6"></i>
                                                                                                        <span>Delete</span>
                                                                                                    </span>
                                                                                                </li>
                                                                                            </ul>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                            </tbody>
                                                        ) : (
                                                            <tr>
                                                                <td className="text-center py-2" colSpan={5}>
                                                                    No Data Found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </>
                                                )}
                                            </table>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EventReminderModal reminderDetails={selectedReminder} modalFlag={modalFlag} nextReminderNumber={(eventReminder?.length || 0) + 1} />
            <DeleteEventReminderModal reminderNumber={reminderNumber} />
        </div>
    );
};
